import type { Partner } from "@/shared-types";

import { formatPartnerName } from "@/shared-types";
import { formatPhoneNumber, validatePhoneNumber } from "@/shared-utils";
import { capitalizeFirstLetter } from "@/shared-utils/formatters/capitalizeFirstLetter";

const GREETING_TEMPLATE =
    "Hi, thanks for calling {partner} Tech Coach, my name is {expertName}. It's my pleasure to assist you.";
export const GREETING_CLOSING = "Let me pull up your account.";

const DEFAULT_COUNTDOWN_DURATION = 10;
const CONNECT_ROUTING_BUFFER = 5;
const MIN_PLAUSIBLE_MS = 1000;
const MAX_PLAUSIBLE_MS = 60000;

export function buildGreeting(partner: Partner | undefined, expertName: string): string {
    return GREETING_TEMPLATE.replace("{partner} ", partner ? `${formatPartnerName(partner)} ` : "").replace(
        "{expertName}",
        capitalizeFirstLetter(expertName),
    );
}

export function getCountdownDuration(rawDurationMs: number | undefined): number {
    if (
        rawDurationMs != null &&
        Number.isFinite(rawDurationMs) &&
        rawDurationMs >= MIN_PLAUSIBLE_MS &&
        rawDurationMs <= MAX_PLAUSIBLE_MS
    ) {
        return rawDurationMs / 1000 + CONNECT_ROUTING_BUFFER;
    }
    return DEFAULT_COUNTDOWN_DURATION;
}

export function getFormattedPhone(phone: string): string {
    if (!phone) return "Incoming call";
    const { valid } = validatePhoneNumber(phone);
    if (!valid) return phone;
    return formatPhoneNumber(phone, "US").number;
}
